import { Dispatch, RefObject, useEffect } from 'react';
import { eventKeyEscape } from '@legacy/constants/keyboardKey';
import { SidePanelActionProps } from '../reducer';

interface UseFocusHandlingProps {
  isSidePanelOpen: boolean;
  sidePanelRef: RefObject<HTMLDivElement | null>;
  activateSidePanelButtonRef?: RefObject<HTMLButtonElement | null>;
  dispatch: Dispatch<SidePanelActionProps> | undefined;
}

export const useFocusHandling = ({
  isSidePanelOpen,
  sidePanelRef,
  activateSidePanelButtonRef,
  dispatch,
}: UseFocusHandlingProps) => {
  useEffect(() => {
    const sidePanel = sidePanelRef?.current;
    if (isSidePanelOpen && sidePanel) {
      sidePanel.focus();

      sidePanelRef?.current?.addEventListener(
        'keydown',
        ({ key }: KeyboardEvent) => {
          if (key === eventKeyEscape && dispatch) {
            dispatch({ type: 'CLOSE_PANEL' });

            if (activateSidePanelButtonRef?.current) {
              activateSidePanelButtonRef.current.focus();
            }
          }
        },
      );
    }
  }, [isSidePanelOpen, dispatch, activateSidePanelButtonRef, sidePanelRef]);
};
